import { ClientError, ClientErrorType } from '@edgebox/data-definition-kit';
import { AnnotationMapEntry, observable, runInAction } from 'mobx';
import { RequestReason } from '.';
import { hasMessageProperty } from '../helpers/hasMessageProperty';

type ErrorCollection = {
  [type in RequestReason]?: ClientError;
};

export class BaseAsyncStore {
  apiErrors: ErrorCollection = {};
  isLoading = false;

  protected _handleError(requestReason: RequestReason, e?: unknown) {
    this.isLoading = false;

    if (!e) {
      console.error('Unexpected request error in component', this, e);
    }
    const error =
      e instanceof ClientError ? e : new ClientError(ClientErrorType.Other, undefined as any, hasMessageProperty(e) ? e.message : '');

    this.apiErrors = { ...this.apiErrors, [requestReason]: error };
  }

  protected async _asyncRequest<T>(request: () => Promise<T>, reason: RequestReason) {
    try {
      const res = await request();
      runInAction(() => {
        this.apiErrors = {};
      });
      return res;
    } catch (e) {
      runInAction(() => {
        this._handleError(reason, e);
      });

      throw e;
    }
  }
}

export const BasAsyncStoreAnnotationsMap: Record<keyof BaseAsyncStore, AnnotationMapEntry> = {
  apiErrors: observable,
  isLoading: observable,
};
